var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresanawhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3465 29.64H2.54264C1.14086 29.64 0 28.4832 0 27.0621V9.02014C0 7.60076 1.14086 6.44308 2.54264 6.44308H5.08703V3.86602H6.5396C7.10793 1.64973 9.08229 0 11.4446 0C13.8094 0 15.782 1.64973 16.3503 3.86602H17.8038V6.44308H20.3465C21.7508 6.44308 22.89 7.60076 22.89 9.02014V27.0621C22.89 28.4832 21.7508 29.64 20.3465 29.64ZM11.4446 2.9048C10.5061 2.9048 9.68454 3.0962 9.2441 3.86602H13.6468C13.2072 3.0962 12.3839 2.9048 11.4446 2.9048ZM15.2603 6.44308H7.63055V9.02014H15.2603V6.44308ZM20.3465 9.02014H17.8038V11.598H5.08703V9.02014H2.54264V27.0621H20.3465V9.02014ZM10.1724 14.1759H12.7168V18.0411H16.5325V20.619H12.7168V24.485H10.1724V20.619H6.35835V18.0411H10.1724V14.1759Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresanawhite);
export default __webpack_public_path__ + "static/media/presanawhite.850beb9ea44c684556ab885a466c3b52.svg";
export { ForwardRef as ReactComponent };